const ENDPOINT = 'https://server-er5erun3ra-uc.a.run.app'
const CLIENT =
  'MfjQCwzFHrbYCoZsPDwZHyFkvEbakvBQaYEiR7vTnjdmgWuPzpoXrVDdYLaVtw94B3VV7bq'

class Logger {
  static visitorId = null
  static country = null

  static async initialize() {
    // Generate or retrieve visitor ID
    this.visitorId = localStorage.getItem('visitorId')
    if (!this.visitorId) {
      this.visitorId = 'v_' + Math.random().toString(36).substring(2, 11)
      localStorage.setItem('visitorId', this.visitorId)
    }

    // Get country information
    try {
      const response = await fetch('https://ipapi.co/json/')
      const data = await response.json()
      this.country = data.country_name || 'Unknown'
    } catch (error) {
      console.error('Error getting country:', error)
      this.country = 'Unknown'
    }
  }

  static async sendNotification(...args) {
    // Ensure we have visitor info
    if (!this.visitorId || !this.country) {
      await this.initialize()
    }

    const message = [this.visitorId, this.country, ...args].join(' | ')

    console.log(message)

    // Don't send logs in development
    if (process.env.NODE_ENV === 'development') {
      return
    }

    try {
      const response = await fetch(`${ENDPOINT}/notifyBot`, {
        method: 'POST',
        headers: {
          client: CLIENT,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: message,
        }),
      })

      if (!response.ok) {
        console.error('Failed to send log:', response.status)
      }
    } catch (error) {
      console.error('Error sending log:', error)
    }
  }

  static debug(tag, ...message) {
    const appName = 'Erase Background Free'
    const version = '1.0.0' // You might want to get this from package.json
    const userAgent = navigator.userAgent
    this.sendNotification(appName, version, tag, userAgent, ...message)
  }

  static logServer(tag, ...message) {
    // Log to console only
    console.log(tag, navigator.userAgent, ...message)
  }

  static notify(tag, critical = true, ...message) {
    const appName = 'Erase Background Free'
    const version = '1.0.0'
    this.sendNotification(
      appName,
      version,
      tag,
      navigator.userAgent,
      ...message
    )
  }
}

// Initialize logger when the module is loaded
Logger.initialize()

export default Logger
